<template>
  <v-container class="grey lighten-5">
    <div v-if="selectedCourse===null">
      <h2>Live Kurse</h2>
      <br/>
      <h3>Erstellen</h3>
      <v-text-field v-model="name" label="Name"/>
      <v-autocomplete
          clearable
          outlined
          persistent-hint
          item-title="title"
          item-text="title"
          item-value="id"
          small-chips
          solo
          :items="courses"
          v-model="course"
          label="Schulung"
      />
      <v-btn class="ma-1" color="info" :loading="loading"
             :disabled="loading || course == null || name === ''" @click="create">
        Live erstellen
        <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
        </template>
      </v-btn>
      <br/>
      <br/>
      <v-divider style="height: 2px"/>
      <br/>
      <br/>
      <div v-for="item in lives" :key="item.id">
        <v-card
            outlined
            tile
        >
          <v-card-title>{{ item.name }}</v-card-title>
          <v-card-subtitle>{{ item.courseName }}: {{ item.participants.length }} Teilnehmer</v-card-subtitle>
          <v-card-actions>
            <v-btn class="ma-2" color="red" x-small fab outlined @click="deleteLive(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn class="ma-2" color="indigo" outlined @click="openLive(item)">
              Öffnen
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>

      <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>Gespeichert</v-snackbar>
      <v-snackbar :timeout="5000" :value="error" color="error" left shaped top>Fehler.</v-snackbar>

    </div>
    <div v-else>
      <v-btn class="ma-2" color="indigo" outlined small @click="selectedCourse = null">
        Zurück
      </v-btn>
      <SuperAdminLiveCourse :live-id="selectedCourse.id"/>
    </div>
  </v-container>

</template>

<script>

import CourseRun from "@/components/CourseExecution.vue";
import Course from "@/models/Course";
import {default as CourseRunModel} from "@/models/CourseRun";
import LiveCourse from "@/models/LiveCourse";
import SuperAdminLiveCourse from "@/components/sites/SuperAdminLiveCourse.vue";

export default {
  name: "SuperAdminLiveCourses",
  components: {SuperAdminLiveCourse},
  data: () => ({
    courses: [],
    lives: [],
    course: null,
    loading: false,
    selectedCourse: null,
    success: false,
    error: false,
    name: "",
    csv: null
  }),
  methods: {
    deleteLive(item) {
      this.loading = true;
      this.$httpLiveCourseApi.delete(item.id, () => {
        this.loadData();
        this.loading = false;
        this.successText = "Erfolgreich gelöscht"
        this.success = true;
        this.loadData();
        setTimeout(() => {
          this.success = false;
        }, 3000);
      });
    },
    openLive(item) {
      this.selectedCourse = item;
    },
    create() {
      this.loading = true;
      this.$httpLiveCourseApi.create(new LiveCourse({name: this.name, courseId: this.course}), () => {
        this.loadData();
        this.loading = false;
        this.successText = "Erfolgreich hochgeladen"
        this.success = true;
        this.name = "";
        this.course = null;
        this.loadData();
        setTimeout(() => {
          this.success = false;
        }, 3000);
      });
    },

    loadData() {
      this.$httpCourseApi.getAll((result) => {
        this.courses = result;
      });
      this.$httpLiveCourseApi.getAll((result) => {
        this.lives = result;
      });
    },
    fileSelected(file) {
      this.csv = file;
    },
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
